import React, { useEffect, useRef, useState } from "react";
import { Button } from "components/core/Button";
import { CONTENT, TABS } from "./StorageUnitSizeContent";
import "./StorageUnitSizeModal.scss";

const TRIANGLE_OFFSET_RATIO = 4;

export default function StorageUnitSizeModal() {
	const [active, setActive] = useState(TABS[0]);
	const wrapperRef = useRef(null);
	const data = CONTENT[active];

	useEffect(() => {
		const wrapper = wrapperRef.current;
		if (!wrapper) return;

		const activeBtn = wrapper.querySelector(
			".unit-size-guide__tab.is-active"
		);

		if (!activeBtn) return;

		const wrapperRect = wrapper.getBoundingClientRect();
		const btnRect = activeBtn.getBoundingClientRect();
		const centerX = btnRect.left + btnRect.width / TRIANGLE_OFFSET_RATIO - wrapperRect.left;

		wrapper.style.setProperty("--triangle-x", `${centerX}px`);
	}, [active]);

	return (
		<div
			className="unit-size-guide"
			ref={wrapperRef}
		>
			<div
				className="unit-size-guide__tabs"
				role="tablist"
			>
				{TABS.map((tab) => (
					<Button
						key={tab}
						role="tab"
						aria-selected={active === tab}
						aria-controls={`tabpanel-${tab}`}
						id={`tab-${tab}`}
						className={`unit-size-guide__tab ${
							active === tab ? "is-active" : ""
						}`}
						onClick={() => setActive(tab)}
					>
						{tab}
					</Button>
				))}
			</div>

			<div className="unit-size-guide__triangle" />
			<div
				className="unit-size-guide__content"
				role="tabpanel"
				id={`tabpanel-${active}`}
				aria-labelledby={`tab-${active}`}
			>
				<span className="unit-size-guide__title">{data?.title}</span>
				{data &&
					Object.entries(data)
						.filter(([key]) => key !== "title")
						.map(([key, value]) => (
							<div
								className="unit-size-guide__row"
								key={key}
							>
								<strong className="unit-size-guide__label">
									{key}
								</strong>
								<span className="unit-size-guide__value">
									{value}
								</span>
							</div>
						))}
			</div>
		</div>
	);
}
